"use client";

import { useTranslations } from "next-intl";
import LegalPage from "./legal-page";

const TermsOfServiceContent = () => {
  const t = useTranslations("legalPages.termsOfService");

  const sections = t.raw("sections") as Array<{
    title: string;
    content: string | string[];
  }>;

  return (
    <LegalPage
      title={t("title")}
      lastUpdated={t("lastUpdated")}
      intro={t("intro")}
      sections={sections}
    />
  );
};

export default TermsOfServiceContent;
